import React, { Fragment, useEffect, useState } from 'react';
import {SzButton, SzModal, SzInput} from '@suezenv/react-theme-components'
import {IEditFilterModal} from "../../../../../type/signal.type";
import '../signal-advanced-filter.scss';
import { useTranslationWithPrefix } from '../../../../../hooks/translation';

export const EditFilterModal : React.FC <IEditFilterModal>= ({
	setShowEditModal,
	showEditModal,
	deleteFavoriteFilter,
	editFavoriteFiltersLabel,
	selectedFavoriteFilterLabel
}) => {
	const trans = useTranslationWithPrefix("signalement", "form_filter");
	const [favoriteFilterLabel, setFavoriteFilterLabel] = useState<string>("");

	useEffect(() => {
		setFavoriteFilterLabel(selectedFavoriteFilterLabel);
	}, [selectedFavoriteFilterLabel]);

	return (
		<Fragment>
				<SzModal
					border="smooth"
					title={trans('advanced_filters.edit_filter_title')}
					size="sm"
					centered={true}
					backdrop={'static'}
					show={showEditModal}
					className={'modals-favorite-filter'}
				>   
				<SzInput
					placeholder={trans('advanced_filters.new_filter_label')}
					value={favoriteFilterLabel}
					onChange={e => setFavoriteFilterLabel(e.target.value)}
				/>
				<div className="d-flex justify-content-between mt-3">
					<div>
						<SzButton variant="tertiary" className="mr-2" onClick={() => {
							setFavoriteFilterLabel(selectedFavoriteFilterLabel); 
							setShowEditModal(false);
						}}>
							{trans('advanced_filters.cancel')}
						</SzButton>
					</div>
					<div>
						<SzButton variant="tertiary" className="ml-2" onClick={() => { deleteFavoriteFilter() }} >
							{trans('advanced_filters.delete_filter')}
						</SzButton>
						<SzButton
							variant="secondary"
							isDisabled={favoriteFilterLabel.trim() === "" ? true : false}
							onClick={() => {
								editFavoriteFiltersLabel(favoriteFilterLabel);
								setShowEditModal(false);
							}}
						>
							{trans('advanced_filters.save')}
						</SzButton>
					</div>
				</div>
			</SzModal>
		</Fragment>
	);
};

export default EditFilterModal;